import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconErrorFill';
/** Renders an SVG icon. */
const SvgErrorFill = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M22.043 2c.58 0 1.132.252 1.512.69l5.957 6.873a2 2 0 0 1 .488 1.31v10.254a2 2 0 0 1-.488 1.31l-5.957 6.873c-.38.438-.932.69-1.512.69H9.957c-.58 0-1.132-.252-1.512-.69l-5.957-6.873A2 2 0 0 1 2 21.127V10.873a2 2 0 0 1 .488-1.31L8.445 2.69c.38-.438.932-.69 1.512-.69zM10 14.5a1.5 1.5 0 0 0 0 3h12a1.5 1.5 0 0 0 0-3z"
        clipRule="evenodd"
      />
    </svg>
  );
};
SvgErrorFill.displayName = displayName;
export default SvgErrorFill;
